import {Component, Input} from '@angular/core';
import {Equipment, isFinal, isReceived} from "../../api/model/equipment";

@Component({
  selector: 'app-equipment-status',
  templateUrl: './status.component.html',
  styleUrl: './status.component.sass'
})
export class EquipmentStatusComponent {
  @Input() equipment!: Equipment;

  statusClass(e: Equipment): string {
    const received = (isReceived(e.status)) ? " received" : "";
    const final = (isFinal(e.status)) ? " final" : "";

    return received + final + " status-" + e.status;
  }
}
